import { Grid } from "@mui/material";
import { AuthContext } from "core/contexts/auth/auth";
import { searchDocumentsSubmittal } from "modules/agentMySecurity/services/embeddingsService";
import { useContext, useState } from "react";
import { FormContainer, FormTitle, StyledTextField, ActionButton } from "./home.styled";

function SearchDocuments() {
    const { checkAuthToken } = useContext(AuthContext);
    const [formData, setFormData] = useState({
        collectionName: "",
        searchString: "",
        embedModel: "",
    });

    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    async function handleSubmit(e) {
        e.preventDefault();
        const token = await checkAuthToken();
        searchDocumentsSubmittal(token, formData);
    }

    return (
        <FormContainer>
            <form id="searchForm" onSubmit={handleSubmit}>
                <FormTitle>Search Document</FormTitle>
                <Grid container spacing={3} direction="column">
                    <Grid item>
                        <StyledTextField
                            name="collectionName"
                            label="Collection Name (empty for all)"
                            fullWidth
                            variant="outlined"
                            value={formData.collectionName}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item>
                        <StyledTextField
                            name="searchString"
                            label="Search String"
                            fullWidth
                            required
                            variant="outlined"
                            value={formData.searchString}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item>
                        <StyledTextField
                            name="embedModel"
                            label="Embed Model (empty for all)"
                            fullWidth
                            variant="outlined"
                            value={formData.embedModel}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item>
                        <ActionButton
                            type="submit"
                            variant="contained" 
                            color="primary" 
                            fullWidth
                        >
                            Search
                        </ActionButton>
                    </Grid>
                </Grid>
            </form>
        </FormContainer>
    );
}

export default SearchDocuments;